import { queryOptions, useQuery } from '@tanstack/react-query';

import { getOrganization } from '../actions/getOrganization';

type GetOrganizationParams = {
  sourcedId: string;
};

export const getOrganizationQueryOptions = (params: GetOrganizationParams) => {
  return queryOptions({
    queryKey: ['organization', params.sourcedId],
    queryFn: async () => {
      const response = await getOrganization({ data: params });
      return response.data;
    },
    staleTime: 0,
  });
};

export const useGetOrganization = (params: GetOrganizationParams) => {
  return useQuery(getOrganizationQueryOptions(params));
};
